/**
 * PhysicalDescriptionSection - Physical descriptors and additional IDs
 */

import { OathInput } from '../../../../shared/OathUI';
import { ACCEPT_QUOTE_FIELD_MAX_LENGTH } from '../../shared/requestFieldLimits';

const PhysicalDescriptionSection = ({ formState, dispatch, requiredFields }) => {
  const isRequired = (field) => requiredFields.includes(field);
  const set = (field) => (val) => dispatch({ type: 'SET_FIELD', field, value: val });

  return (
    <div>
      <h4 className="text-sm font-semibold text-gray-900 dark:text-white mb-3">Physical Description & Identifiers</h4>
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-3">
        <OathInput
          label="Hair Color"
          maxLength={ACCEPT_QUOTE_FIELD_MAX_LENGTH.hairColor}
          value={formState.hairColor}
          onChange={set('hairColor')}
          placeholder="e.g., Brown"
          required={isRequired('hairColor')}
        />
        <OathInput
          label="Eye Color"
          maxLength={ACCEPT_QUOTE_FIELD_MAX_LENGTH.eyeColor}
          value={formState.eyeColor}
          onChange={set('eyeColor')}
          placeholder="e.g., Blue"
          required={isRequired('eyeColor')}
        />
        <OathInput
          label="Weight"
          value={formState.weight}
          onChange={(val) => dispatch({ type: 'SET_FIELD', field: 'weight', value: val.replace(/\D/g, '') })}
          placeholder="e.g., 180"
          suffix="lbs"
          required={isRequired('weight')}
        />
        <OathInput
          label="Height"
          value={formState.height}
          onChange={(val) => dispatch({ type: 'SET_FIELD', field: 'height', value: val.replace(/\D/g, '') })}
          placeholder="e.g., 72"
          suffix="in"
          required={isRequired('height')}
        />
        <OathInput
          label="XREF Number"
          maxLength={ACCEPT_QUOTE_FIELD_MAX_LENGTH.xrefNumber}
          value={formState.xrefNumber}
          onChange={set('xrefNumber')}
          placeholder="XREF #"
          required={isRequired('xrefNumber')}
        />
        <OathInput
          label="PFN Number"
          maxLength={ACCEPT_QUOTE_FIELD_MAX_LENGTH.pfnNumber}
          value={formState.pfnNumber}
          onChange={set('pfnNumber')}
          placeholder="PFN #"
          required={isRequired('pfnNumber')}
        />
      </div>
    </div>
  );
};

export default PhysicalDescriptionSection;
